import React from "react";
import { Button, Column, Heading, Row } from "@hex-insights/core";
import { useActivePageRegistration, useHistory } from "@hex-insights/router";
import { ButtonLink, Icon } from "@hex-insights/verita-romania.shared";
import { ReEnrollmentLayout } from "../../Components";
import { reEnrollmentMealPlansPageInfo } from "../../MealPlansPage/pageinfo";
import { reEnrollmentPaymentPlansGroupedPageInfo } from "../GroupedPage/pageinfo";
import { reEnrollmentPaymentPlansIndividualPageInfo } from "../IndividualPage/pageinfo";
import { reEnrollmentPaymentPlansDefinitionSelectionPageInfo } from "./pageinfo";
import generalStyles from "../../general.module.css";
import styles from "./styles.module.css";

export function ReEnrollmentPaymentPlansDefinitionSelectionPage() {
	useActivePageRegistration(reEnrollmentPaymentPlansDefinitionSelectionPageInfo);

	const [value, setValue] = React.useState<string | null>(null);

	const onChange = React.useCallback((event: React.ChangeEvent<HTMLInputElement>) => {
		if (event.target.checked) {
			setValue(event.target.value);
		}
	}, []);

	const history = useHistory();
	const onSubmit = React.useCallback(() => {
		if (value === "separate-plans") {
			history.push(reEnrollmentPaymentPlansIndividualPageInfo.to);
			return;
		}
		if (value === "one-plan") {
			history.push(reEnrollmentPaymentPlansGroupedPageInfo.to);
			return;
		}
	}, [value, history]);

	return (
		<ReEnrollmentLayout
			footerContent={
				<Row justify="space-between" align="center">
					<ButtonLink variant="link" to={reEnrollmentMealPlansPageInfo.to}>
						<Row justify="spaced-start" align="center" horizontalSpacing="0.25rem">
							<Icon.ArrowLeft size={24} /> Back
						</Row>
					</ButtonLink>

					<Button variant="primary" onClick={onSubmit} disabled={value === null}>
						Continue
					</Button>
				</Row>
			}
		>
			<div className={styles["payment-plan-definition-main-content"]}>
				<Heading.H2 className={generalStyles["heading"]}>Please select your payment plan preference</Heading.H2>

				<Column justify="spaced-start" verticalSpacing="1rem">
					<label className={styles["payment-plan-definition-field__option"]}>
						<input
							type="radio"
							name="paymentPlanSelection"
							value="one-plan"
							checked={value === "one-plan"}
							onChange={onChange}
						/>

						<Column justify="spaced-start" verticalSpacing="0.25rem" style={{ flexGrow: 1 }}>
							<Row justify="space-between" style={{ gap: "1rem" }}>
								<span className={styles["payment-plan-definition-field__option__name"]}>One Plan</span>
								<span className={styles["payment-plan-definition-field__option__recommended"]}>Recommended</span>
							</Row>
							<span className={styles["payment-plan-definition-field__option__description"]}>
								Combine all students' tuition and fees into one payment plan.
							</span>
						</Column>
					</label>

					<label className={styles["payment-plan-definition-field__option"]}>
						<input
							type="radio"
							name="paymentPlanSelection"
							value="separate-plans"
							checked={value === "separate-plans"}
							onChange={onChange}
						/>

						<Column justify="spaced-start" verticalSpacing="0.25rem" style={{ flexGrow: 1 }}>
							<span className={styles["payment-plan-definition-field__option__name"]}>Separate Plans</span>
							<span className={styles["payment-plan-definition-field__option__description"]}>
								Create separate payment plans for each student's tuition and fees.
							</span>
						</Column>
					</label>
				</Column>
			</div>
		</ReEnrollmentLayout>
	);
}
